import type { ReactNode } from "react";

import logo from "@/assets/img/logo.svg";
import { Progress } from "@/components/ui";
import { cn } from "@/utils/Functions";

import { WELCOME_TOTAL_STEPS } from "../constants";
import { ShaderEffect } from "@/components/primitives/custom-shader";

export function WelcomeStageLayout({
  step,
  leftPanel,
  children,
}: {
  step: number;
  leftPanel: ReactNode;
  children: ReactNode;
}) {
  const progressValue = ((step + 1) / WELCOME_TOTAL_STEPS) * 100;

  return (
    <div className="grid min-h-screen lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)]">
      <aside
        className={cn(
          "relative flex flex-col overflow-hidden border-border border-r px-9 py-7",
          // "bg-gradient-to-br from-card via-card to-muted/40",
        )}
      >
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
        >
          <ShaderEffect className="h-full w-full" />
        </div>

        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-black/45"
        />

        <div className="relative z-10 flex items-center gap-3">
          <img src={logo} alt="Equal IQ" className="h-8 w-auto" />
        </div>

        <div className="relative z-10 flex flex-1 items-center py-8">{leftPanel}</div>

        <div className="relative z-10 space-y-2">
          <Progress variant="secondary" value={progressValue} className="h-1 gap-0" />
          <span className="font-mono text-[11px] text-muted-foreground">
            {String(step + 1).padStart(2, "0")} / {String(WELCOME_TOTAL_STEPS).padStart(2, "0")}
          </span>
        </div>
      </aside>

      <section className="flex min-h-0 flex-col overflow-hidden bg-background">{children}</section>
    </div>
  );
}
